import React, { useEffect } from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useLists } from "@/context/ListsContext";

export default function Customers() {
  const { refreshCustomers } = useLists();

  useEffect(() => {
    // refresh when navigating away/back
    return () => refreshCustomers();
  }, [refreshCustomers]);

  const columns = [
    { key: "name", label: "Customer", type: "text", required: true, placeholder: "Customer name" },
    { key: "company", label: "Company", type: "text", width: 200 },
    { key: "email", label: "Email", type: "text", width: 220 },
    { key: "phone", label: "Phone", type: "text", width: 160 },
    { key: "notes", label: "Notes", type: "text" },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Customers"
        title="Customer List"
        description="Add and edit customers. They'll show up in dropdowns across Jobs, Quotes, Artwork, and Send-Offs."
      />
      <ItemsTable
        endpoint="customers"
        columns={columns}
        defaultItem={{ name: "", email: "", phone: "", company: "", notes: "" }}
        testIdPrefix="customers"
        emptyLabel="No customers yet — add your first one above."
      />
    </div>
  );
}
